import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DevicesClass } from '@app/core/classes/component/devices.class';
import { CitiesService } from '@app/modules/cities-module/cities.service';
import { FundamentalsService } from '@app/modules/fundamentals-modules/fundamentals.service';
import { RoutingConfig } from '@app/routing/routing.config';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
declare var $;

@UntilDestroy()
@Component({
  selector: 'shared-instruments',
  templateUrl: 'main-instruments.component.html',
  styleUrls: [`./main-instruments.component.scss`],
})

export class MainInstrumentsComponent extends DevicesClass implements OnInit {
  public Routing = RoutingConfig;
  public SwitcherForm: FormGroup;
  public SwitcherStatus: boolean;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private router: Router,
    private citiesService: CitiesService,
    private fundamentalsService: FundamentalsService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.onMoveMobileBalls();

    this.SwitcherForm = this.formBuilder.group({
      type: [false, Validators.required]
    });

    this.onSwitcherFormCtrl();
  }

  onSwitcherFormCtrl(): void {
    this.SwitcherForm.valueChanges.pipe(untilDestroyed(this)).subscribe(
      value => {
        this.SwitcherStatus = value.type;
      }
    );
  }

  onSetSwitcher(value: boolean): void {
    this.SwitcherForm.controls.type.setValue(value);
  }

  onMoveMobileBalls(): void {
    if (this.deviceValue.getValue() === this.DTypes.Mobile) {
      $('.__js__instruments-slider').animate({
        scrollLeft: 60
      }, 500);
    }
  }

  onSearchLink(id: number): void {
    const City = this.citiesService.onGetSelectedCity() || this.fundamentalsService.citiesRecommendations[0];

    this.router.navigateByUrl(
      `/${this.Routing.Bulletins}/${this.Routing.Search}?type=${this.SwitcherStatus ? 2 : 1}&cities=${City.id || 0}&instruments=${id}`
    ).catch();
  }
}
